export default "__VITE_ASSET__7c946fe3__"